import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useImageCompressingContext } from '../../../../contexts/ImageCompressingContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import CircumstanceManager from '../Circumstance/CircumstanceManager';
import ProjectDetail from './ProjectDetail';
import ProjectItem from './ProjectItem';
import ProjectPanel from './ProjectPanel';

function ProjectPage({ isActive }) {
  const { openPRNAProjectDetail, navigationContext } = useNavigationContext();
  const [projectList, setProjectList] = useState([]);
  const { accountContext } = useAccountContext();
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [circumstanceManagerIsOpen, setCircumstanceManagerIsOpen] = useState(false);
  const [selectedCircumstance, setSelectedCircumstance] = useState(undefined);
  const { setImageCompressingContext } = useImageCompressingContext();

  useEffect(() => {
    if (navigationContext.acitveProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext]);

  useEffect(() => {
    fetchProjectList();
  }, []);

  const fetchProjectList = async () => {
    await privateFetch('GET', 'prna', `/cu/${accountContext.id}/project/`).then((res) => {
      setProjectList(res);
    });
  };

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'prna',
      `/cu/${accountContext.id}/project/${navigationContext.acitveProjectId}`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then((res) => {
      fetchProjectList();
      setPanelIsOpen(false);
      setLoading(false);
      openPRNAProjectDetail(res);
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/project/${projectDetail.id}/`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const handleDeleteCircumstance = async (circumstance) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/circumstance/${circumstance.id}/`,
      'La circonstance a bien été supprimée'
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setSelectedCircumstance(undefined);
    });
  };

  const createProjectCircumstance = async (circonstanceForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/project/${projectDetail.id}/circumstance/`,
      'La circonstance a bien été enregistrée',
      JSON.stringify(circonstanceForm)
    ).then((res) => {
      fetchProjectList();
      fetchProjectDetail();
      setLoading(false);
      setCircumstanceManagerIsOpen(false);
    });
  };

  const handleClickProject = (project) => {
    openPRNAProjectDetail(project);
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const handleCreateCircumstance = () => {
    setSelectedCircumstance(undefined);
    setCircumstanceManagerIsOpen(true);
  };

  const updateCircumstance = async (circumstanceForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/circumstance/${selectedCircumstance.id}/`,
      'La circonstance a bien été modifié',
      JSON.stringify(circumstanceForm)
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setLoading(false);
      setCircumstanceManagerIsOpen(false);
    });
  };

  const deleteCircumstance = async (circumstance) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/circumstance/${circumstance.id}/`,
      'La circonstance a bien été supprimée'
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setSelectedCircumstance(undefined);
    });
  };

  const itemTemplate = (project) => (
    <ProjectItem project={project} handleClickProject={() => handleClickProject(project)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        action={projectDetail ? goBackProjectAction : newProjectAction}
        detail={projectDetail}>
        {!projectDetail ? (
          <DataView value={projectList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleCreateCircumstance={handleCreateCircumstance}
            handleDeleteCircumstance={handleDeleteCircumstance}
            onSelectCircumstance={(crc) => {
              setSelectedCircumstance(crc);
              setCircumstanceManagerIsOpen(true);
            }}
            handleDelete={handleDeleteProject}
          />
        )}
        <ProjectPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          project={projectDetail}
          onCreate={createProject}
          onUpdate={updateProject}
          loading={loading}
        />
      </PageWrapper>

      <CircumstanceManager
        isOpen={circumstanceManagerIsOpen}
        onClose={() => {
          setSelectedCircumstance(undefined);
          setCircumstanceManagerIsOpen(false);
        }}
        circumstance={selectedCircumstance}
        onCreate={createProjectCircumstance}
        onUpdate={updateCircumstance}
        onDelete={deleteCircumstance}
        loading={loading}
      />
    </div>
  );
}

export default ProjectPage;
